import type { PackageState } from "../slice";

export const getPackagesByRateId = (state: PackageState) => {
  return state.packages.hotel.shop.data?.packageStateByRateId;
};
